import { Model } from '@vuex-orm/core'

export class LessonTeacher extends Model {
  static entity = 'lessonTeacher'
  static primaryKey = ['lesson_id', 'teacher_id']

  static fields () {
    return {
      lesson_id: this.attr(null),
      teacher_id: this.attr(null)
    }
  }
}

export default LessonTeacher
